import { ErthNav } from "../erth/ErthNav";
import { ErthHero } from "../erth/ErthHero";
import { ErthStory } from "../erth/ErthStory";
import { ErthProjects } from "../erth/ErthProjects";
import { ErthExperiences } from "../erth/ErthExperiences";
import { ErthJournalStrip } from "../erth/ErthJournalStrip";
import { ErthContact } from "../erth/ErthContact";
import { ErthFooter } from "../erth/ErthFooter";
import { useSeo } from "../hooks/useSeo";
import { ORGANIZATION, DUNE_LODGING, graph } from "../seo/schema";

export default function ErthHome() {
  useSeo({
    title: "erth. escapes | Thoughtfully crafted escapes across India",
    description:
      "erth. escapes creates innovative spaces that harmonize with nature: eco-conscious residences and immersive retreats across India. First project: Dune Villas at Area 83 near Bengaluru.",
    path: "/",
    image: "/images/lounge-palms.webp",
    jsonLd: graph(
      ORGANIZATION,
      { "@type": "WebSite", name: "erth. escapes", url: "__ORIGIN__/", publisher: { "@id": "__ORIGIN__/#organization" } },
      DUNE_LODGING
    ),
  });

  return (
    <div data-testid="erth-home" className="min-h-screen bg-erth-beige font-body">
      <ErthNav />
      <main>
        <ErthHero />
        <ErthStory />
        <ErthProjects />
        <ErthExperiences />
        <ErthJournalStrip />
        <ErthContact />
      </main>
      <ErthFooter />
    </div>
  );
}
